<div [ngClass]="buttonText ? 'vstack gap-2' : ''">
    <div [ngClass]="title ? 'vstack gap-0 card border-bottom-0' : ''">
        @if (title) {
            <h5 class="fw-semibold p-4 m-0 fs-5">
                {{ title }}
            </h5>
        }
        @if (description) {
            <p class="text-body-secondary px-4 pb-2 m-0">
                {{ description }}
            </p>
        }
        <ng-content select="[warning]"></ng-content>
        <ul [ngClass]="title ? 'list-group border-0' : 'list-group'">
            <ng-content></ng-content>
        </ul>
    </div>
    @if (buttonText) {
        <button
            class="btn btn-outline-secondary align-self-start"
            type="button"
            [disabled]="buttonDisabled"
            (click)="onButtonClick()"
        >
            {{ buttonText }}
        </button>
    }
</div>
